// Texts shared by every ERP screen (pt-BR; same voice as the rest of the portal).
export default {
  section: 'ERP',
  nav: {
    dashboard: 'Painel',
    crm: 'Visão geral',
    customers: 'Clientes',
    activities: 'Atividades',
    history: 'Histórico',
    projects: 'Projetos',
    tasks: 'Tarefas',
    calendar: 'Agenda',
    meetings: 'Reuniões',
    finance: 'Lançamentos',
    invoices: 'Faturas',
    catalog: 'Catálogo',
    proposals: 'Propostas',
    tickets: 'Chamados',
    ticketsAll: 'Chamados das instituições',
    support: 'Suporte',
    employees: 'Funcionários',
    suppliers: 'Fornecedores',
    accounts: 'Contas financeiras',
    financialCategories: 'Categorias financeiras',
    classificationRules: 'Regras de classificação',
    activityTypes: 'Tipos de atividade',
    projectTemplates: 'Modelos de projeto',
    projectFileTypes: 'Tipos de arquivo',
    automations: 'Automações comerciais',
    wiki: 'Wiki',
    reports: 'Relatórios',
    projectsReport: 'Projetos e tarefas',
    hours: 'Horas',
    granola: 'Gravações',
    workSchedules: 'Escalas de trabalho',
    financeMonthly: 'Receitas e despesas mensais',
    commissionsReport: 'Comissões a fechar',
  },
  // Busca e criação rápida, Ctrl+K (17/10/2026).
  palette: {
    open: 'Buscar e criar (Ctrl+K)',
    trigger: 'Buscar',
    placeholder: 'Buscar cliente, projeto, tarefa ou o que fazer…',
    none: 'Nada encontrado.',
    groups: { actions: 'Criar', screens: 'Ir para', customers: 'Clientes', projects: 'Projetos', tasks: 'Tarefas' },
    actions: {
      task: 'Nova tarefa',
      meeting: 'Nova reunião',
      activity: 'Nova atividade',
      contact: 'Registrar contato',
      customer: 'Novo cliente',
      project: 'Novo projeto',
      proposal: 'Nova proposta',
    },
  },
  records: {
    accountsPage: {
      title: 'Contas financeiras',
      subtitle: 'Contas bancárias, caixa e cartões de crédito, com o saldo de hoje.',
      new: 'Nova conta',
    },
    categoriesPage: {
      title: 'Categorias financeiras',
      subtitle: 'Categorias de receita e de despesa (até dois níveis) usadas nos lançamentos.',
      new: 'Nova categoria',
    },
    activityTypesPage: {
      title: 'Tipos de atividade',
      subtitle: 'Os tipos das atividades do CRM (acompanhamento, apresentação comercial...).',
      new: 'Novo tipo',
    },
  },
  navGroups: {
    records: 'Cadastros',
    crm: 'CRM',
    projects: 'Projetos',
    finance: 'Financeiro',
    reports: 'Relatórios',
  },
  modules: {
    crm: 'CRM',
    projetos: 'Projetos',
    financeiro: 'Financeiro',
    comercial: 'Comercial',
    chamados: 'Chamados',
    rh: 'RH',
    wiki: 'Wiki',
  },
  moduleHints: {
    crm: 'Clientes, contatos e acompanhamentos',
    projetos: 'Projetos, tarefas, agenda e reuniões',
    financeiro: 'Lançamentos, contas, extrato, fornecedores e fluxo de caixa',
    comercial: 'Catálogo, propostas e faturas (precisa do CRM)',
    chamados: 'Chamados de suporte e melhorias',
    rh: 'Cadastro de funcionários',
    wiki: 'Base de conhecimento interna',
  },
  permissions: {
    crm_ver: 'Ver clientes e CRM',
    crm_editar: 'Cadastrar e editar clientes e acompanhamentos',
    crm_automacoes: 'Administrar automações comerciais (regras, frequências, feriados e modelos de e-mail)',
    projetos_ver: 'Ver projetos, tarefas, agenda e reuniões',
    projetos_editar: 'Criar e editar projetos, tarefas, agenda e reuniões',
    financeiro_ver: 'Ver o financeiro',
    financeiro_editar: 'Lançar e editar no financeiro',
    comercial_ver: 'Ver catálogo, propostas e faturas',
    comercial_editar: 'Criar e editar propostas e faturas',
    propostas_decidir: 'Aprovar, recusar e cancelar propostas',
    chamados_ver: 'Ver chamados',
    chamados_editar: 'Abrir e editar chamados, registrar acompanhamentos e mudar o status',
    chamados_transferir: 'Transferir chamados para outra pessoa (técnicos)',
    chamados_monitorar: 'Acompanhar os chamados de todas as instituições (só leitura; equipe da plataforma)',
    suporte_abrir: 'Abrir e acompanhar chamados com o suporte da plataforma',
    rh_ver: 'Ver funcionários (dados pessoais)',
    rh_editar: 'Cadastrar e editar funcionários',
    wiki_ver: 'Ler a wiki',
    wiki_editar: 'Escrever na wiki',
    horas_ver: 'Ver as próprias horas apontadas',
    horas_editar: 'Apontar horas e usar o timer',
    horas_todas: 'Ver e corrigir as horas de todas as pessoas',
    horas_aprovar: 'Aprovar as horas fora do expediente de todas as pessoas',
    horas_pacotes: 'Cadastrar os pacotes de horas dos clientes e ver o saldo',
    relatorios_ver: 'Ver relatórios',
    carteiras_todas: 'Ver todas as carteiras (clientes, projetos e tarefas de todos os consultores)',
  },
  documents: {
    title: 'Dados da empresa nos documentos',
    // "Enviar por e-mail" of a meeting's record (19/10/2026).
    meetingReport: {
      title: 'Relatório de reunião',
      hint: 'Quem recebe por padrão o registro da reunião ("Enviar por e-mail"). Quem envia fica de fora na hora.',
      recipients: 'Enviar para',
      placeholder: 'socio1@empresa.com.br, socio2@empresa.com.br',
    },
    // "Enviar por e-mail" of a proposal (23/10/2026): who gets a copy.
    proposalEmail: {
      title: 'Envio da proposta por e-mail',
      hint: 'Quem recebe cópia de toda proposta enviada por e-mail. Quem envia fica de fora.',
      cc: 'Cópia (Cc)',
      placeholder: 'socio1@empresa.com.br, socio2@empresa.com.br',
    },
    // A new proposal's defaults (19/10/2026).
    defaults: {
      title: 'Padrões da proposta nova',
      hint: 'Toda proposta nova já começa assim (dá para mudar em cada uma). Os vencimentos são sugeridos: entrada em 7 dias, 1ª parcela 30 dias depois e mensalidade no dia 10 do mês seguinte.',
      noCondition: 'Sem padrão',
      validityHint: 'Vazio = 7 dias.',
    },
    intro: 'Aparecem na proposta comercial em PDF (cabeçalho, aceite e rodapé). Nada da plataforma é impresso.',
    companyName: 'Nome da empresa',
    companyEmail: 'E-mail de contato',
    companyTagline: 'Frase da empresa',
    companyTaglineHint: 'Ex.: Tecnologia · Automação · IA',
    approvalText: 'Texto do “Aceite”',
    approvalTextHint: 'Vazio usa o texto padrão: pedimos a confirmação por e-mail, WhatsApp ou assinatura.',
    logos: 'Logos do PDF',
    logosHint: 'PNG ou JPG até 8 MB. O PDF usa o logo escuro (fundo claro); o claro fica guardado para outros documentos.',
    lightLogo: 'Logo claro (fundo escuro)',
    darkLogo: 'Logo escuro (o do PDF)',
    noLogo: 'Sem logo: o nome da empresa aparece no lugar.',
    sendLogo: 'Enviar logo',
    removeLogo: 'Remover',
    onlyImages: 'Envie o logo em PNG ou JPG.',
    readOnly: 'Só quem administra a empresa altera estes dados.',
  },
  common: {
    disabledTitle: 'ERP não disponível',
    disabledText: 'Este módulo não está ativo para a sua empresa. Fale com o suporte para ativá-lo.',
    forbiddenTitle: 'Sem permissão',
    forbiddenText: 'O seu papel não dá acesso a esta área. Peça a quem administra a empresa.',
    search: 'Buscar',
    moreFilters: 'Mais filtros',
    clearFilters: 'Limpar filtros',
    new: 'Novo',
    create: 'Criar',
    save: 'Salvar',
    edit: 'Editar',
    delete: 'Excluir',
    cancel: 'Cancelar',
    close: 'Fechar',
    actions: 'Ações',
    all: 'Todos',
    // "Todas" for feminine nouns (situação, prioridade, categoria, conta...).
    allFeminine: 'Todas',
    none: 'Nenhum',
    nobody: 'Não atribuído',
    noCustomer: 'Sem cliente',
    noProject: 'Sem projeto',
    newSupplierOption: '+ Novo fornecedor…',
    newCustomer: '+ Novo cliente…',
    newProject: '+ Novo projeto…',
    newCustomerTitle: 'Novo cliente',
    newProjectTitle: 'Novo projeto',
    customerName: 'Nome ou razão social',
    projectTitle: 'Título do projeto',
    customer: 'Cliente',
    project: 'Projeto',
    responsible: 'Responsável',
    description: 'Descrição',
    status: 'Status',
    value: 'Valor',
    date: 'Data',
    loading: 'Carregando',
    loadError: 'Não foi possível carregar. Tente novamente.',
    retry: 'Tentar novamente',
    empty: 'Nada por aqui ainda',
    noMatch: 'Nada encontrado com esses filtros.',
    saved: 'Alterações salvas',
    created: 'Cadastro criado',
    deleted: 'Excluído',
    confirmDeleteTitle: 'Excluir “{name}”?',
    confirmDeleteText: 'Esta ação não pode ser desfeita.',
    records: 'Nenhum registro | 1 registro | {count} registros',
    pageOf: 'Página {page} de {total}',
    previous: 'Anterior',
    next: 'Próxima',
    download: 'Baixar',
    upload: 'Enviar arquivo',
    attachments: 'Anexos',
    fileTooBig: 'O arquivo “{name}” passa de 8 MB.',
    yes: 'Sim',
    no: 'Não',
  },
}
